/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Value/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Value({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Form/ReferralsSection/Referrals/Referral/Kind/Person/Value"
  
}) {
let newPatientReferralTextValueValueData = fromData.useDataValue({ viewPath,
context: 'new_patient_referral',
path: 'text_value',
})
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Value.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={dtTypographyFontsizeM}
 data="new_patient_referral.text_value"
 text={newPatientReferralTextValueValueData}
/>
</div>
{children}
</React.Fragment>)
}